module.exports = __webpack_public_path__ + "static/img/20221224_03.db514c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221224_03.png
// module id = Ev1v
// module chunks = 0